import { NextRequest, NextResponse } from 'next/server';
import { getCookie } from 'cookies-next';
import { IncomingMessage, ServerResponse } from 'http';

type Request = IncomingMessage & {
  cookies?: Partial<{
    [key: string]: string;
  }>;
};

type Response = ServerResponse<IncomingMessage>;

type Context =
  | {
      req?: Request;
      res?: Response;
    }
  | { req: NextRequest; res: NextResponse };

const checkIsNextContext = (
  context: Context
): context is { req: NextRequest; res: NextResponse } => {
  return Boolean((context.req as NextRequest)?.nextUrl);
};

const extractCookie = (context?: Context): string => {
  if (context && checkIsNextContext(context)) {
    return context.req.cookies.get('authDomainSSO')?.value || 'null';
  }

  return String(getCookie('authDomainSSO', context) || 'null');
};

export const extractToken = (context?: Context): string | null => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT || 'integration';

  const cookieValue = extractCookie(context);

  try {
    const authDomainSSO = JSON.parse(cookieValue) as {
      token: string;
      environment: string;
    };

    if (authDomainSSO && authDomainSSO.environment === environment) {
      return authDomainSSO.token;
    }
  } catch (e) {
    console.error('=== extractToken json parse error', e);
  }

  return null;
};

// TODO: AuthKey extractor
